/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Try_Now_FreeInputs */

const en_read_along_try_now_free = /** @type {(inputs: Read_Along_Try_Now_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try now for free`)
};

const es_read_along_try_now_free = /** @type {(inputs: Read_Along_Try_Now_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probar gratis ahora`)
};

/**
* | output |
* | --- |
* | "Try now for free" |
*
* @param {Read_Along_Try_Now_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_try_now_free = /** @type {((inputs?: Read_Along_Try_Now_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Try_Now_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_try_now_free(inputs)
	return en_read_along_try_now_free(inputs)
});